
/*
ashraf 10/16/2022  2700708915  added code comments in search, add user management.
prakash 26/10/2022 2700708915  added classes for new table UI and added lock icon.
akhila 10/31/2022 2700708915 TablePagination bugFix
saikrishna 11/03/2022 2700708915 Changed paginationOptions
Raghu 11/29/2022 2700708915 Table Footer Styling Fixes
Ashraf 12/07/2022  2700708915 fixed user login name field
Dilip 01/05/2023  2700708915 fixed sorting issue
Dilip 01/06/2023  2700708915 displayed user login name in table column
Suresh peddavoora 02/17/2023 2700708915 unLock user table alignments
Sohel 02/17/2023 2700708915 Added Condition
suresh peddavoora 03/01/2023 2700708915 New UI changes

*/

import {Grid, TablePagination} from '@material-ui/core';
// import MaterialTable from "material-table";
import React, {createRef, useEffect, useState} from 'react';
import {tableIcons} from '../../../components/TableIcons';
import {defaultRows, tablePageRows} from '../../../constants/ReusableTablePagination';
import {httpPaginationPost} from '../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {useUpdateEffect} from 'react-use';
import {lockedUser} from '../../../redux/reducers/UserManagement/UnlockUser';
import moment from 'moment';
import {ErrorSnackbar, SuccessSnackbar} from '../../../components/CustomSnackBar';
import {ResetMessage as resetMessage, ResetStatus as resetStatus} from '../../../redux/reducers/UserManagement/UnlockUser';
import TableHeaderText from '../../../util/TableHeaderText';
import GuiTable from '../../../components/FormComponents/GuiTable';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';

// table with locked users details (2700708915)
const UnlockUser = ({
  submit,
  searchData,
}) => {
  const tableRef = createRef();

  const [rows, setRows] = useState(defaultRows);
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [countTotal, setCountTotal] = useState('');

  const {unlockingUserStatus, errorMsg, isLoading, successMsg} = useSelector(({unLockUser}) => unLockUser);

  // recall table api after search details submit (2700708915)
  useUpdateEffect(() => {
    if (tableRef?.current) {
      tableRef.current.onQueryChange();
    }
  }, [searchData]);

  // recall table api after a user is unlocked (2700708915)
  useEffect(() => {
    if (unlockingUserStatus === 200) {
      tableRef.current.onQueryChange();
    }
  }, [unlockingUserStatus]);

  // reset redux state when success, error or locking status is true (2700708915)
  useEffect(() => {
    if (unlockingUserStatus || successMsg || errorMsg) {
      setTimeout(() => {
        dispatch(resetMessage());
        dispatch(resetStatus());
      }, 2500);
    }
  }, [successMsg, errorMsg, unlockingUserStatus]);

  const columns = [
    {
      title: 'User Login Name',
      field: 'userLoginName',
    },
    {
      title: 'Email Id',
      field: 'emailId',
    },
    {
      title: 'Roles',
      field: 'roles',
      render: (rowData) => (
        <>
          <div
            style={{
              maxWidth: 250,
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData?.roles ? rowData?.roles : ''}
          </div>
        </>
      ),
    },
    {
      title: 'Company Code',
      field: 'companyCodeList',
      render: (rowData) => {
        if (rowData?.companyCodeList?.length === 1) {
          return rowData.companyCodeList;
        } else if (rowData?.companyCodeList?.length > 1) {
          return rowData?.companyCodeList?.reduce(
            (acc, item, index) =>
              index < rowData?.companyCodeList?.length - 1 ? acc + item + ', ' : acc + item + '',
            '',
          );
        }
      },
    },
    {
      title: 'Location',
      field: 'location',
    },
    {
      title: 'Deactivated Date',
      field: 'deactiveDate',
      render: (rowData) =>
        rowData.deactiveDate ? moment(rowData.deactiveDate).format('MM/DD/YYYY') : '',
      minWidth: 50,
      type: 'date',
    },
    {
      title: 'Is Active',
      field: 'isActive',
    },
  ];
  return (
    <>
      <Grid item xs={12}>
        <div className="custom-table global-field-table new-standard-textfields">
          <GuiTable
            title={
              <TableHeaderText countTotal={countTotal} />
            }
            columns={columns}
            icons={tableIcons}
            isLoading={isLoading}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `search/lock/user`;
                const bodyObj = {
                  isActive: searchData?.isActive === true ? 'Y' : searchData?.isActive === false ? 'N' : '',
                  location: searchData?.location ? searchData?.location : '',
                  emailId: searchData?.emailId ? searchData?.emailId : '',
                  userName: searchData?.userName ? searchData?.userName : '',
                  limit: query.pageSize ? query.pageSize : null,
                  orderBy: query?.orderBy && query?.orderBy?.field === 'roles' ? 'roleName' : 
                    query?.orderBy?.field === 'companyCodeList' ? 'companyCode' : 
                      query?.orderBy?.field === 'userName' ? 'userLoginName' : query?.orderBy?.field ? query?.orderBy?.field : '',
                  orderDirection: query.orderDirection,
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObject;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setCountTotal(response.data.response.count);
                      setArrayLast(data.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              })
            }
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            options={{
              search: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            actions={[
              (rowData) => ({
                icon: () => <LockOutlinedIcon/>,
                tooltip: 'Unlock user',
                onClick: (event, rowData) => dispatch(lockedUser(rowData?.userId)),
              }),
            ]}
          />
        </div>
        {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
        {successMsg && <SuccessSnackbar successMsg={successMsg} />}
      </Grid>
    </>
  );
};

export default UnlockUser;
